module.exports = __webpack_public_path__ + "static/media/DSCF6326.e9312aaa.jpg";